<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">参与的每一个活动，</p>
        <p  class="font1" style="padding-top: 1vh;">获得的每一张证书，</p>
        <p  class="font1" style="padding-top: 1vh;">都是你不断追求卓越的印记～</p>
        <p  class="font1" style="padding-top: 1vh;">坚持不懈地学习与成长，</p>
        <p  class="font1" style="padding-top: 1vh;">你的职场之路将更加宽广</p>


        <div style="width: 84%;margin: 0 auto;margin-top: 3vh;" v-if="ReportData.activity">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">参与活动：</p>
            <ul v-for="(item,index) in projectName" :key="index">
                <li>{{ item }}</li>
            </ul>
        </div>

        <div style="width: 84%;margin: 0 auto;margin-top: 3vh;" v-if="ReportData.activity">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">获得荣誉：</p>
            <ul v-for="(item,index) in certificate" :key="index">
                <li>{{ item }}</li>
            </ul>
        </div>

        <p class="font1" style="color: #176ed2;margin-top: 5vh;">{{ ReportData.textLab.text }}</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            projectName:[],
            certificate:[],
            themeLink:''
        }
    }, 
    created(){
        // const coc=JSON.parse(this.ReportData.coc)
        // this.themeLink=JSON.parse(this.ReportData.themeLink)
        const activity=JSON.parse(this.ReportData.activity)
        // console.log(activity,'证书');
        if(activity !==null){
            activity.forEach(obj => {
                // 将每个对象中的"name"和"certificate"的值分别存储到对应的数组中
                this.projectName.push(obj.project_name);
                this.certificate.push(obj.certificate);
                // console.log(this.certificate,'证书');
            });
        }
        // console.log(this.themeLink,'11')
        // console.log(coc,'coc');
        // if(coc !== null){
        //   this.coc=coc
        // }
    },
    computed:{},
    mounted(){
        
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/logo2.png") right  top  no-repeat,
                url("../../assets/24July/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 90%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #176ed2;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #176ed2;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>